const translations = {
    ddmSyncFailure: 'Error syncing Exedy DDM flights. Please try again later.',
    ddmSyncSuccess: 'Exedy DDM Flights synced successfully.',
    invalidOrganizationError: 'Invalid organization identifier'
};

export default translations;
